import { render, staticRenderFns } from "./LocalTabs.vue?vue&type=template&id=29440a25&scoped=true&"
import script from "./LocalTabs.vue?vue&type=script&lang=js&"
export * from "./LocalTabs.vue?vue&type=script&lang=js&"
import style0 from "./LocalTabs.vue?vue&type=style&index=0&id=29440a25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29440a25",
  null
  
)

export default component.exports